import React, { useEffect, useState } from 'react';
import greenArrow from '@/app/assets/images/green-arrow.webp';
import Image from 'next/image';

const MovingArrowsAnim = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused] = useState(false); // State to control pause
  const totalArrows = 6;

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % totalArrows);
      }, 150);

      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, [isPaused]); // Depend on isPaused, re-trigger effect when paused/unpaused

  const renderArrows = () => {
    return Array.from({ length: totalArrows }).map((_, index) => {
      const isActive = index === activeIndex;
      return (
        <div
          key={index}
          style={{
            margin: '0px',
            // transform: isActive ? 'scale(1.2)' : 'scale(1)',
            transition: 'transform 0.15s ease',
          }}
        >
          <Image
              src={greenArrow}
              width={18}
              height={13}
              alt="Arrow"
              className="mx-1"
              style={{
                  opacity: isActive ? 1 : 0.5,
                  filter: isActive ? 'brightness(1)' : 'brightness(0.8)',
                  transition: 'opacity 0.15s ease, filter 0.15s ease',
              }}
          />
        </div>
      );
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {renderArrows()}
      </div>
    </div>
  );
};

export default MovingArrowsAnim;